/* eslint-disable react-hooks/rules-of-hooks */
import React, { useCallback, useState } from "react";

// Redux
import { useSelector } from "react-redux";

//Importation of the 'AgentCard' componnent, what'll be used to mount the table return of logged agents
import AgentCard from "./sub/AgentCard/index";
import AgentList from "./sub/AgentList/index";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

import { ModalConfirmLogout } from "./sub/ButtonLogout";

import { MDBTypography } from "mdbreact";

import "./AgentsTableBody.scss";

//i18n
import { withTranslation } from "react-i18next";

import { Duration } from "luxon";

//Here the control for how many cards'll be displayed and the threating of the agent's require
const index = ({ t, ...props }) => {
  const { mainTheme } = useSelector((state) => state.Layout);
  const logoutUserActive = useSelector(
    (state) => state.Manager.idAgentLogoutOpen
  );

  let payload = props?.isAgentCard
    ? props?.payloadData
    : props?.payloadData?.map((item) => ({
        ...item,
        status: (
          <div>
            {item.status === "online" ? (
              <span className="td-online"></span>
            ) : item.status === "backsoon" ? (
              <span className="td-backsoon"></span>
            ) : item.status === "offline" || item.status === "away" ? (
              <span className="td-offline"></span>
            ) : (
              <span className="td-other"></span>
            )}
            <span className="ml-1">{item.status_description}</span>
          </div>
        ),
        name: (
          <MDBTypography className="text-muted text-left">
            {item.name}
          </MDBTypography>
        ),
        capacity: (
          <MDBTypography className="text-muted">
            {(parseFloat(item.capacity) * 100).toFixed(2) + "%"}
          </MDBTypography>
        ),
        csat: (
          <MDBTypography className="text-muted">
            {item?.csat ? (parseFloat(item?.csat) * 100).toFixed(2) + "%" : "-"}
          </MDBTypography>
        ),
        status_duration: (
          <MDBTypography className="text-muted">
            {item.status_duration
              ? Duration.fromObject({
                  seconds: item.status_duration,
                }).toFormat(
                  item.status_duration < 60
                    ? "ss's'"
                    : item.status_duration < 3600
                    ? "mm'm' ss's'"
                    : "hh'h' mm'm'"
                )
              : "--"}
          </MDBTypography>
        ),
        msgs_gerais: (
          <MDBTypography className="text-muted">
            {item.msgs_gerais}
          </MDBTypography>
        ),
        msgs_fechadas: (
          <MDBTypography className="text-muted">
            {item.msgs_fechadas}
          </MDBTypography>
        ),
        msgs_atribuidas: (
          <MDBTypography className="text-muted">
            {item.msgs_atribuidas}
          </MDBTypography>
        ),
      }));

  return (
    <>
      {props.isAgentCard ? (
        props.loadingData ? (
          <div className="text-center">
            <span>{t("Loading...")}</span>
          </div>
        ) : Array.isArray(payload) && payload?.length > 0 ? (
          <div className="w-100 mt-5">
            <PerfectScrollbar className="agents-content">
              <div className="row w-100">
                {payload.map((agentDataItem) => (
                  <div
                    className={`col-card-agent ${
                      mainTheme === "dark" ? "dark" : "light"
                    } col-sm-12 col-md-6 col-lg-3 mt-1`}
                    key={agentDataItem.name}
                  >
                    <AgentCard
                      handleRefresh={props.handleRefresh}
                      agentId={agentDataItem.id}
                      agentAvailability={agentDataItem?.availabilities}
                      agentAvatar={agentDataItem.url_avatar}
                      agentStatus={
                        agentDataItem.status !== "online" &&
                        agentDataItem.status !== "offline" &&
                        agentDataItem.status !== "backsoon" &&
                        agentDataItem.status !== "away"
                          ? "other"
                          : agentDataItem.status
                      }
                      agentStatusDescription={agentDataItem.status_description}
                      agentName={agentDataItem.name}
                      agentTime={agentDataItem.time}
                      agentCapacity={
                        (parseFloat(agentDataItem.capacity) * 100).toFixed(2) +
                        "%"
                      }
                      agentCSAT={
                        agentDataItem?.csat
                          ? (parseFloat(agentDataItem?.csat) * 100).toFixed(2) +
                            "%"
                          : "-"
                      }
                      agentStateDuration={
                        agentDataItem.status_duration
                          ? Duration.fromObject({
                              seconds: agentDataItem.status_duration,
                            }).toFormat(
                              agentDataItem.status_duration < 60
                                ? "ss's'"
                                : agentDataItem.status_duration < 3600
                                ? "mm'm' ss's'"
                                : "hh'h' mm'm'"
                            )
                          : "--"
                      }
                      assignedMessages={agentDataItem.msgs_gerais}
                      closedMessages={agentDataItem.msgs_fechadas}
                      activatedMessages={agentDataItem.msgs_atribuidas}
                      max_chats={agentDataItem.max_chats}
                      skills={agentDataItem.skills}
                    />
                  </div>
                ))}
              </div>
            </PerfectScrollbar>
          </div>
        ) : (
          <div className="no-matching-records">
            <span>{t("No matching records found")}</span>
          </div>
        )
      ) : (
        <AgentList tableData={payload} loadingData={props.loadingData} />
      )}

      <ModalConfirmLogout id={logoutUserActive} isOpen={!!logoutUserActive} />
    </>
  );
};

export default withTranslation()(index);
